import React from "react";
import {Link as MuiLink} from "@material-ui/core";
import {Link as RouterLink} from 'react-router-dom';
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";


/**
 * Link using React-router as the destination
 */
export function ListItemButtonRouterLink(props) {
  const {primary, to, icon} = props;
  const CustomLink = React.useMemo(
    () =>
      React.forwardRef((linkProps, ref) => (
        <RouterLink ref={ref} to={to} {...linkProps} />
      )),
    [to],
  );
  return (
    <ListItem button component={CustomLink}>
      {icon && <ListItemIcon>{icon}</ListItemIcon>}
      <ListItemText primary={primary}/>
    </ListItem>
  );
}


export function ListItemButtonAbsoluteLink(props) {
  const {primary, to, icon} = props;
  const CustomLink = React.useMemo(
    () =>
      React.forwardRef((linkProps, ref) => (
        <MuiLink ref={ref} href={to} {...linkProps} />
      )),
    [to],
  );
  return (
    <ListItem button component={CustomLink} style={{textDecoration: 'none'}}>
      {icon && <ListItemIcon>{icon}</ListItemIcon>}
      <ListItemText primary={primary}/>
    </ListItem>
  );
}

